import PropTypes from "prop-types";
import React from "react";
import { Button, IconButton, Box, Typography } from "@mui/material";
import { Add, SaveAlt, PlayCircleFilled } from "@mui/icons-material";
import { Tooltip } from "../../../../components/Tooltip";
import ManageRepositorySearch from "./ManageRepositorySearch";
import { useTranslation } from "react-i18next";

const ManageRepositoryHeaderActions = ({
  onAddItemClick,
  downloadDisabled,
  addItemDisabled,
  previewItemDisabled,
  downloadTooltipText,
  onPreviewItemClick,
  onDownloadClick,
  searchDisabled,
  searchVisible,
  handleSearchItem
}) => {
  const { t } = useTranslation();
  const downloadButton = () => (
    <IconButton
      color="primary"
      disabled={downloadDisabled}
      onClick={onDownloadClick}
      data-qa="manage-repo-download-btn"
      size="large"
    >
      <SaveAlt />
    </IconButton>
  );
  const downloadButtonWithTooltip = () => (
    <Tooltip
      title={
        <Typography
          variant="body2"
          color="textSecondary"
          data-qa="manage-repo-download-tooltip-text"
        >
          {downloadTooltipText}
        </Typography>
      }
    >
      <span>{downloadButton()}</span>
    </Tooltip>
  );

  return (
    <Box display="flex">
      {searchVisible && (
        <ManageRepositorySearch
          disabled={searchDisabled}
          handleSearchItem={handleSearchItem}
        />
      )}
      {onPreviewItemClick && (
        <IconButton
          color="primary"
          onClick={onPreviewItemClick}
          disabled={previewItemDisabled}
          data-qa="preview-repository-item-btn"
          size="large"
        >
          <PlayCircleFilled />
        </IconButton>
      )}
      {onAddItemClick && (
        <Button
          color="primary"
          onClick={onAddItemClick}
          disabled={addItemDisabled}
          startIcon={<Add />}
        >
          {t("manageRepository.newItem")}
        </Button>
      )}
      {onDownloadClick &&
        (downloadTooltipText ? downloadButtonWithTooltip() : downloadButton())}
    </Box>
  );
};

ManageRepositoryHeaderActions.propTypes = {
  /**
   * If true, the actions contain the preview button
   */
  showPreviewButton: PropTypes.bool,
  /**
   * If true, the download button is disabled
   */
  downloadDisabled: PropTypes.bool,
  /**
   * If true, the archive button is disabled
   */
  archiveDisabled: PropTypes.bool,
  downloadTooltipText: PropTypes.string,
  /**
   * Called when the add item button is clicked
   */
  onAddItemClick: PropTypes.func,
  /**
   * Called when the archive button is clicked
   */
  onArchiveClick: PropTypes.func,
  /**
   * Called when the download button is clicked
   */
  onDownloadClick: PropTypes.func,
  /**
   * If true, the archive button is disabled
   */
  searchDisabled: PropTypes.bool,
  searchVisible: PropTypes.bool,
  /**
   * Called when search is clicked
   */
  handleSearchItem: PropTypes.func
};

ManageRepositoryHeaderActions.defaultProps = {
  searchVisible: true
};

export default ManageRepositoryHeaderActions;
